import type { ReactNode } from 'react';

import { cn } from '../lib/cn';

export interface EmptyStateProps {
  /** A Lucide icon at `strokeWidth={2}`, sized 18–24. */
  icon?: ReactNode;
  title: ReactNode;
  description?: ReactNode;
  /** A single call to action, usually a Button. */
  action?: ReactNode;
  className?: string;
}

/**
 * The designed empty state (rules §17.4, tokens doc §10.3): centred, 40px/24px padding,
 * icon in neutral-300, copy in neutral-500. Used inside a Card or a Table.
 */
export function EmptyState({ icon, title, description, action, className }: EmptyStateProps) {
  return (
    <div className={cn('flex flex-col items-center px-6 py-10 text-center', className)}>
      {icon === undefined ? null : (
        <span className="mb-3 text-neutral-300" aria-hidden="true">
          {icon}
        </span>
      )}
      <p className="text-base font-semibold text-ink">{title}</p>
      {description === undefined ? null : (
        <p className="mt-1 max-w-sm text-base text-neutral-500">{description}</p>
      )}
      {action === undefined ? null : <div className="mt-5">{action}</div>}
    </div>
  );
}
